<div class="container">
  <div class="title">
    <h1 mat-dialog-title>Repayment Report</h1>
  </div>

  <div
    class="content"
    mat-dialog-content
  >
    <table>
      <tbody>
        <tr>
          <td>Outstanding</td>
          <td>&#8377; {{ data.outstanding }}</td>
        </tr>
        <tr>
          <td>Not Due</td>
          <td>&#8377; {{ data.notDue }}</td>
        </tr>
        <tr>
          <td>Due 1-30</td>
          <td>&#8377; {{ data.due1To30Days }}</td>
        </tr>
        <tr>
          <td>Due 31-60</td>
          <td>&#8377; {{ data.due31To60Days }}</td>
        </tr>
        <tr>
          <td>Due 61-90</td>
          <td>&#8377; {{ data.due61To90Days }}</td>
        </tr>
        <tr>
          <td>Due 90+</td>
          <td>&#8377; {{ data.due90PlusDays }}</td>
        </tr>
      </tbody>
    </table>

    <p>
      Disclaimer: Repayment details above may be delayed upto 2 business days and do not include late payment
      charges,if any.
    </p>

    <p>For latest updated ledger, please reach out to your RM and reach out to us accounts&#64;zippmat.com</p>
  </div>

  <div
    mat-dialog-actions
    class="submit"
  >
    <button
      mat-raised-button
      (click)="onClose()"
      color="secondary"
    >
      Close
    </button>
  </div>
</div>
